import fitty from 'fitty';

/* eslint-disable */
export default {
    init() {
        // JavaScript to be fired on the home page
        var featuredCarousel = $('.featured__wrap');
        if ( featuredCarousel.length > 0 ) {
            featuredCarousel.flickity({
                watchCSS: true,
                prevNextButtons: false,
                pageDots: false,
                cellAlign: 'left',
                wrapAround: false,
                contain: true,
                percentPosition: true,
                autoPlay: 4000,
                pauseAutoPlayOnHover: true,
            })
        }

        var latestGrid = $('.post-grid__wrap');
        if ( latestGrid.length > 0 ) {
            var $grid = $('.post-grid__wrap').imagesLoaded(function () {
                $grid.masonry({
                    columnWidth: '.post-card',
                    itemSelector: '.post-card',
                    gutter: '.post-grid__gutter-sizer',
                    percentPosition: true,
                });
            });
        }
    },
    finalize() {
        // Fittext
      fitty('.hero__header');
      fitty('.hero__subheader');
    },
};

/* eslint-enable */
